import { useDispatch } from "react-redux";

import { setGlobalGroupBy } from "store/features";

import {
  AutomationHandler,
  useRegisterHandlerWithBroker
} from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import { SetFocusPayload } from "components/automation/types/payloads";
import { CommandResult } from "components/automation/types/results";
import { Topic, Topics } from "components/automation/types/topics";

export function GroupByAutomationHandler() {
  const dispatch = useDispatch();

  const handler: AutomationHandler = {
    id: "groupby-automation-handler",
    handles: function (topic: Topic): boolean {
      return topic === Topics.SetFocus;
    },
    executeCommand: function (command: AutomationCommand): Promise<CommandResult> {
      if (command.topic === Topics.SetFocus) {
        const payload = command.payload as SetFocusPayload;
        if (payload && payload.property) {
          // Set the global group by state using Redux action
          dispatch(setGlobalGroupBy(payload));
        }
      }
      return Promise.resolve({
        status: "ok"
      });
    }
  };
  useRegisterHandlerWithBroker(handler);

  return <></>;
}
